import initAnalytics from '../src/analytics/tracker';

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => initAnalytics());
} else {
	initAnalytics();
}
